import React from 'react'

import { Form, Col, Select } from 'antd'

import { getMessage } from '../../util/IntlMessages'
import { transformOnValidJSONString } from '../../util/transformOnValidJSONString'
import CustomLabel from '../CustomLabel/CustomLabel'

const { Option } = Select

const CustomSelectMultiple = function ({
  errors,
  setFieldValue,
  rowSpan,
  value,
  values,
  field,
  onChange,
  multiple,
  enable,
  onChangeWithField,
  showSearch,
  onSearch,
  loading,
  notFoundContent,
  suffixLabel,
  name = '',
  placeholder,
  label,
  icon,
  title,
  information
}) {
  const renderFieldName = name ? name : field
  const labelName = label || `${getMessage(field)}${suffixLabel ? ' '.concat(suffixLabel) : ''}`
  const renderLabel = CustomLabel(labelName, { value, name, field, information, title, icon })
  const selectValue = multiple ? transformOnValidJSONString(value[renderFieldName]) : value[renderFieldName]

  return (
    <Col xs={24} sm={24} md={rowSpan} lg={rowSpan} xl={rowSpan}>
      <Form.Item
        label={renderLabel}
        validateStatus={errors[renderFieldName] ? 'error' : 'validating'}
        help={errors[renderFieldName]}
      >
        <Select
          showSearch={showSearch || false}
          onSearch={onSearch || (() => {})}
          disabled={enable || false}
          mode={multiple ? 'multiple' : ''}
          name={renderFieldName}
          placeholder={placeholder ? placeholder : getMessage('select')}
          onChange={(value) => {
            setFieldValue(renderFieldName, value)
            if (onChange) {
              onChange(value)
            }

            if (onChangeWithField) {
              onChangeWithField(renderFieldName, value)
            }
          }}
          optionFilterProp="children"
          value={selectValue}
          filterOption={(input, option) => option.props.children.toLowerCase().includes(input.toLowerCase())}
          loading={loading || false}
          notFoundContent={notFoundContent}
        >
          {values.map((item) => (
            <Option key={parseInt(item.value)} value={item.value}>
              {item.description}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Col>
  )
}

export default CustomSelectMultiple
